exports.getFlag = require('./flags')
exports.getLogo = require('./logos')
